import { z } from 'zod';
import { InvoiceGenerationStatusSchema } from '../common/enums.js';
export const InvoiceGenerationJobSchema = z.object({
    id: z.string(),
    tenant_id: z.string(),
    environment_id: z.string(),
    contract_id: z.string(),
    customer_id: z.string(),
    period_key: z.string(),
    billing_period_from: z.string(),
    billing_period_to: z.string(),
    status: InvoiceGenerationStatusSchema,
    invoice_id: z.string().nullable(),
    retry_count: z.number(),
    error_message: z.string().nullable(),
    processing_started_at: z.string().nullable(),
    processing_completed_at: z.string().nullable(),
    processing_duration_ms: z.number().nullable(),
    created_at: z.string(),
    updated_at: z.string(),
});
export const TriggerBillingRunSchema = z.object({
    contract_ids: z.array(z.string()).optional(),
    force: z.boolean().default(false).optional(),
});
export const InvoiceGenerationQuerySchema = z.object({
    page: z.coerce.number().min(1).default(1).optional(),
    limit: z.coerce.number().min(1).max(100).default(20).optional(),
    status: InvoiceGenerationStatusSchema.optional(),
    contract_id: z.string().optional(),
    customer_id: z.string().optional(),
});
//# sourceMappingURL=index.js.map